import React from "react";
import styled from "styled-components";
import { mixinSkins } from "../../../skins/shared/mixins/themeStyles";
import { SkinId } from "../../../skins/types";
import { riotProductSkin } from "../skins/riot-product";
import { RichText } from "../../../components/RichText";
import { CTA } from "../../../components/CTA";
const _BladeHeaderCentered = ({ className, supertitle, title, subtitle, description, links, ...bladeProps }) => {
    return (React.createElement("div", { "data-testid": "blade-header-centered", className: `blade-header-centered ${className}`, ...bladeProps },
        supertitle && (React.createElement("div", { "data-testid": "blade-header-centered-super-title", className: "blade-header-centered--super-title" }, supertitle)),
        title && (React.createElement("div", { "data-testid": "blade-header-centered-title", className: "blade-header-centered--title" }, title)),
        subtitle && (React.createElement("div", { "data-testid": "blade-header-centered-subtitle", className: "blade-header-centered--subtitle" }, subtitle)),
        description && (React.createElement(RichText, { "data-testid": "blade-header-centered-rich-text", className: "blade-header-centered--rich-text", ...description })),
        links && links[0] && (React.createElement("div", { "data-testid": "blade-header-centered-link", className: "blade-header-centered--link" },
            React.createElement(CTA, { "data-testid": "blade-header-centered-link-cta", variant: "primary", ...links[0] })))));
};
export const BladeHeaderCentered = styled(_BladeHeaderCentered) `
  ${mixinSkins({
    [SkinId.RiotProduct]: riotProductSkin,
})}
`;
//# sourceMappingURL=BladeHeaderCentered.js.map